import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 9,
	height: 10.5,
	viewBox: "0 0 9 10.5",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.97554 1.74926C1.90945 1.88252 1.87466 2.03375 1.8747 2.1877V8.3123C1.87466 8.46625 1.90945 8.61748 1.97554 8.75074C2.04164 8.88399 2.13671 8.99454 2.25115 9.07123C2.36559 9.14791 2.49536 9.18802 2.62734 9.1875C2.75932 9.18697 2.88885 9.14584 3.00284 9.06825L7.50339 6.00595C7.61683 5.92887 7.71093 5.8184 7.7763 5.6856C7.84167 5.5528 7.87601 5.40232 7.8759 5.24919C7.87579 5.09605 7.84122 4.94564 7.77565 4.81297C7.71009 4.6803 7.61582 4.57003 7.50227 4.49318L3.00284 1.43175C2.88885 1.35416 2.75932 1.31303 2.62734 1.31251C2.49536 1.31198 2.36559 1.35209 2.25115 1.42877C2.13671 1.50546 2.04164 1.61601 1.97554 1.74926Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
